/**
 * lodash@4.17.23 throttle
 * https://lodash.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under MIT license <https://lodash.com/license>
 *
 * Thin wrapper around HB.debounce (loaded first alphabetically).
 * Exposes window.HB.throttle.
 */
;(() => {
  var FUNC_ERROR_TEXT = "Expected a function"

  function isObject(value) {
    var type = typeof value
    return !!value && (type == "object" || type == "function")
  }

  function throttle(func, wait, options) {
    var leading = true,
      trailing = true

    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT)
    }
    if (isObject(options)) {
      leading = "leading" in options ? !!options.leading : leading
      trailing = "trailing" in options ? !!options.trailing : trailing
    }
    return HB.debounce(func, wait, {
      leading: leading,
      maxWait: wait,
      trailing: trailing,
    })
  }

  window.HB = window.HB || {}
  window.HB.throttle = throttle
})()
